import { render, staticRenderFns } from "./tiscAccordion.vue?vue&type=template&id=2202e2ee&"
import script from "./tiscAccordion.vue?vue&type=script&lang=js&"
export * from "./tiscAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports